import Image from 'next/image';
import Link from 'next/link';
import { cn } from '../lib/utils';

export const Logo = ({ className, uniColor }: { className?: string; uniColor?: boolean }) => {
    return (
        <div className={cn('flex items-center gap-2', className)}>
            <LogoIcon />
            {/* Text - LUMMENY */}
            <span className="text-sm font-bold tracking-wide text-black">LUMMENY</span>
        </div>
    )
}

export const LogoLink = ({ className }: { className?: string }) => {
    return (
        <Link href="/">
            <Logo />
        </Link>
    )
}

export const LogoIcon = ({ className, uniColor }: { className?: string; uniColor?: boolean }) => {
    return (
        <div className={cn('flex h-7 w-7 items-center justify-center rounded-md', className)}>
            <Image
                src="/logo.svg"
                alt="Lummeny"
                width={24}
                height={24}
            />
        </div>
    )
}

export const LogoText = ({ className }: { className?: string }) => {
    return <span className={cn('text-sm font-bold tracking-wide', className)}>LUMMENY</span>
}

export const LogoStroke = ({ className }: { className?: string }) => {
    return (
        <div className={cn('flex items-center gap-2', className)}>
            <LogoIcon />
            {/* Text - LUMMENY */}
            <span className="text-sm font-bold tracking-wide">LUMMENY</span>
        </div>
    )
}
